import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { initSentry } from './lib/sentry';
import App from './App.tsx';
// Two variable fonts, one file each, full 100-900 range. Lexend Deca is the
// single text face; Inter survives only for numerals, because Lexend Deca
// ships no `tnum` and its digit advances span 500-620/1000em — see the `.num`
// utility in index.css and the typography canon in src/CLAUDE.md.
import '@fontsource-variable/lexend-deca';
import '@fontsource-variable/inter';
import './index.css';
import { trpc, trpcClient, queryClient } from './lib/trpcClient';
import { ClerkWrapper } from './lib/clerk';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { registerChunkReloadHandler } from './lib/chunkReload';
import { PortalBrandProvider } from './contexts/PortalBrandContext';

initSentry();
registerChunkReloadHandler();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <ClerkWrapper>
        <trpc.Provider client={trpcClient} queryClient={queryClient}>
          <QueryClientProvider client={queryClient}>
            <PortalBrandProvider>
              <App />
            </PortalBrandProvider>
          </QueryClientProvider>
        </trpc.Provider>
      </ClerkWrapper>
    </ErrorBoundary>
  </StrictMode>
);
